import { Box, Typography, Button } from "@mui/material";
import ReusableInfoModal from "../../General/ReusableInfoModal/ReusableInfoModal";
import { useNavigate } from "react-router-dom";

const OwnerCompanyInfoModal = ({
  id,
  open,
  onClose,
}: {
  id: string;
  open: boolean;
  onClose: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <ReusableInfoModal
      endpoint="ownerCompany"
      entityId={id}
      open={open}
      onClose={onClose}
      title="Company Information"
      renderData={(company) => (
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography>Name:</Typography>
            <Button
              variant="text"
              onClick={() => navigate(`/company/${id}/assets`)}
              sx={{
                textTransform: "none",
                color: "primary.main",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {company.name}
            </Button>
          </Box>
          <Typography>Manager: {company.managerName}</Typography>
          <Typography>
            Manager phone number: {company.managerPhoneNumber}
          </Typography>
          <Typography>Billing Contact: {company.billingContactName}</Typography>
          <Typography>
            Billing Contact Phone: {company.billingContactPhoneNumber}
          </Typography>
          <Typography>Tax Id: {company.taxId}</Typography>
          <Typography>DOT Number: {company.dotNumber}</Typography>
          <Typography>MC Number: {company.mcNumber}</Typography>
          <Typography>Address Line 1: {company.addressLine1}</Typography>
          <Typography>Address Line 2: {company.addressLine2}</Typography>
          <Typography>City: {company.city}</Typography>
          <Typography>State: {company.state}</Typography>
          <Typography>Zip Code: {company.zipCode}</Typography>
        </Box>
      )}
    />
  );
};

export default OwnerCompanyInfoModal;
